var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15 0c8.284 0 15 6.716 15 15s-6.716 15-15 15S0 23.284 0 15 6.716 0 15 0m0 2C7.82 2 2 7.82 2 15s5.82 13 13 13 13-5.82 13-13S22.18 2 15 2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M17.838 12.162 20.676 15m0 0-2.838 2.838M20.27 15H9.324"
  }))));
};
export { SvgArrowCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8cGF0aCBkPSJNMTUgMGM4LjI4NCAwIDE1IDYuNzE2IDE1IDE1IDAgOC4yODQtNi43MTYgMTUtMTUgMTUtOC4yODQgMC0xNS02LjcxNi0xNS0xNUMwIDYuNzE2IDYuNzE2IDAgMTUgMHptMCAyQzcuODIgMiAyIDcuODIgMiAxNXM1LjgyIDEzIDEzIDEzIDEzLTUuODIgMTMtMTNTMjIuMTggMiAxNSAyeiIgaWQ9ImFycm93LWNpcmNsZV9hIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8bWFzayBpZD0iYXJyb3ctY2lyY2xlX2IiIGZpbGw9Im5vbmUiPgogICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhcnJvdy1jaXJjbGVfYSIvPgogICAgPC9tYXNrPgogICAgPHVzZSBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2Fycm93LWNpcmNsZV9hIi8+CiAgICA8ZyBtYXNrPSJ1cmwoI2Fycm93LWNpcmNsZV9iKSIgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgPHBhdGggZD0iTTAgMGgzMHYzMEgweiIvPgogICAgPC9nPgogICAgPHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTE3LjgzOCAxMi4xNjJMMjAuNjc2IDE1TTIwLjY3NiAxNWwtMi44MzggMi44MzhNMjAuMjcgMTVIOS4zMjQiLz4KICA8L2c+Cjwvc3ZnPg==";